const RISKS = [
  {
    tag: "R/01",
    label: "RMD Exposure",
    body: "Required minimum distributions force taxable withdrawals whether you need the income or not — and grow larger every year you delay action.",
  },
  {
    tag: "R/02",
    label: "The Widow's Tax Penalty",
    body: "When a spouse passes, the surviving spouse often faces a dramatically higher tax rate on the same income — a predictable and largely preventable outcome.",
  },
  {
    tag: "R/03",
    label: "IRA Inheritance Taxes",
    body: "Under the SECURE Act's 10-year rule, your heirs may owe ordinary income tax on the full inherited balance. Tax-free alternatives exist.",
  },
  {
    tag: "R/04",
    label: "IRMAA Medicare Surcharges",
    body: "Medicare Part B and D premiums increase sharply at certain income thresholds. Retirement income that could have been managed often isn't.",
  },
  {
    tag: "R/05",
    label: "Legislative & Policy Risk",
    body: "The One Big Beautiful Bill Act (2025) made most TCJA brackets permanent — but \u201Cpermanent\u201D only means no scheduled expiration. Congress can change the law at any time. Planning around current rates, while they last, is still the conservative move.",
  },
  {
    tag: "R/06",
    label: "The Roth Conversion Window",
    body: "The years between retirement and RMD age are often the lowest-tax period of a client's life — and the best opportunity to convert at favorable brackets. Most advisors miss the timing.",
  },
];

export default function SixRisks() {
  return (
    <section
      id="six-risks"
      data-testid="six-risks-section"
      className="py-24 lg:py-32 bg-cream"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
          <div className="lg:col-span-8">
            <div className="flex items-center gap-3 mb-6">
              <span className="text-xs tracking-overline uppercase font-semibold text-accent-gold">
                § 01
              </span>
              <span className="h-px w-10 bg-accent-gold/60" />
              <span className="text-xs tracking-overline uppercase font-semibold text-deep-teal/70">
                The Six Retirement Tax Risks
              </span>
            </div>
            <h2
              className="font-serif font-light text-deep-teal leading-[1.04] tracking-tight"
              style={{ fontSize: "clamp(2.25rem, 4.8vw, 4.25rem)" }}
              data-testid="six-risks-headline"
            >
              Most clients <span className="italic text-accent-gold">never see them coming.</span>
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="text-charcoal-teal text-base leading-relaxed">
              Six exposures that quietly compound — and the framework we use
              to quantify and reduce each one.
            </p>
          </div>
        </div>

        <div
          className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-sage/30 border border-sage/30"
          data-testid="six-risks-grid"
        >
          {RISKS.map((r) => (
            <div
              key={r.tag}
              data-testid={`risk-tile-${r.tag.replace("/", "-").toLowerCase()}`}
              className="bg-cream p-8 lg:p-10 group hover:bg-cream-alt transition-colors flex flex-col"
            >
              <div className="text-[10px] tracking-overline uppercase font-semibold text-accent-gold mb-6">
                {r.tag}
              </div>
              <h3 className="font-serif text-deep-teal text-2xl leading-snug mb-4">
                {r.label}
              </h3>
              <p className="text-charcoal-teal text-sm leading-relaxed">
                {r.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
